import { WidgetProps } from '@rjsf/utils';

import { TextField } from '@mui/material';
import useLinkifiedLabel from './useLinkifiedLabel';

const TextareaWidget = ({ id, placeholder, value, required, disabled, autofocus, label, readonly, onBlur, onFocus, onChange, options, schema, rawErrors = [] }: WidgetProps) => {
  const _onChange = ({ target: { value: val } }: React.ChangeEvent<HTMLInputElement>) => onChange(val === '' ? options.emptyValue : val);
  const _onBlur = ({ target: { value: val } }: React.FocusEvent<HTMLInputElement>) => onBlur(id, val);
  const _onFocus = ({ target: { value: val } }: React.FocusEvent<HTMLInputElement>) => onFocus(id, val);

  let rows: string | number = 5;
  if (typeof options.rows === 'string' || typeof options.rows === 'number') {
    // eslint-disable-next-line prefer-destructuring
    rows = options.rows;
  }

  const displayLabel = useLinkifiedLabel(label);

  return (
    <TextField
      id={id}
      label={displayLabel || schema.title}
      placeholder={placeholder}
      disabled={disabled || readonly}
      value={value}
      required={required}
      autoFocus={autofocus}
      multiline={true}
      rows={rows}
      error={rawErrors.length > 0}
      onChange={_onChange}
      onBlur={_onBlur}
      onFocus={_onFocus}
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{ 'data-testid': 'root_test_text_area_field' }}
    />
  );
};

export default TextareaWidget;
